
import homeSliderImg1 from "../Img/Product6.png";
import { motion } from "framer-motion";
import NewArrival from "./NewArrival";
import Category from "./Category";
import PopularProducts from "./PopularProducts";
import OfferCards from "./OfferCards";
import { useNavigate, Link } from 'react-router-dom';
import { useState } from "react";
import { useEffect } from "react";
import { toast, ToastContainer } from 'react-toastify';
import CategoryWithImages from "./CategoryWithImages";
import Slider from "./Slider/Slider";
import ProductNewCard from "./ProductCard/ProductNewCard";
import AboutMainSection from "./AboutMainSection";
import CountUp from 'react-countup';
import wcuImg from '../Img/main4.webp';
import gridImg from '../Img/main5.webp';
import gridImg2 from '../Img/main6.webp';
import gridImg3 from '../Img/main7.webp';
import gridImg4 from '../Img/main8.webp';
import aboutImg1 from '../Img/main9.webp';
import aboutImg2 from '../Img/NN2NR7V.webp';
import facility1 from '../Img/main10.webp';
import facility2 from '../Img/main11.webp';
import facility3 from '../Img/main12.webp';

const Home = ({ cartItemsLength, setCartItemLength, fetchCart, cartButtons }) => {
    const navigate = useNavigate();
    const [slider, setSlider] = useState([])
    const url = process.env.REACT_APP_API_URL
    const [currentIndex, setCurrentIndex] = useState(0);
    const [variationModalData, setVariationModalData] = useState(null);
    const userData = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || null; // Decrypt cookie data
    const isLoggedIn = !!userData?.user_id;

    const prevSlide = () => {
        setCurrentIndex((prev) =>
            prev === 0 ? slider.length - 1 : prev - 1
        );
    };

    const nextSlide = () => {
        setCurrentIndex((prev) =>
            prev === slider.length - 1 ? 0 : prev + 1
        );
    };

    const current = slider[currentIndex];

    const sliderFetch = async () => {
        try {
            const response = await fetch(`${url}/slider/all/${process.env.REACT_APP_PERFUME_ID}`);
            const res = await response.json();

            const parsed = res.map(slide => {
                const parseSafe = (value, fallback = []) => {
                    try {
                        return typeof value === 'string' ? JSON.parse(value) : value || fallback;
                    } catch {
                        return fallback;
                    }
                };

                // Parse the `product` field
                const parsedProduct = slide.product ? JSON.parse(slide.product) : {};

                return {
                    ...slide,
                    product: {
                        ...parsedProduct,
                        gallery: parseSafe(parsedProduct.gallery),
                        key_features: parseSafe(parsedProduct.key_features),
                        specifications: parseSafe(parsedProduct.specifications),
                        downloadable_files: parseSafe(parsedProduct.downloadable_files),
                        attribute: parseSafe(parsedProduct.attribute),
                        variation: parseSafe(parsedProduct.variation),
                    },
                };
            });

            setSlider(parsed); // ✅ Now slider[i].product is usable
        } catch (error) {
            console.error("Slider fetch error:", error);
            toast.error("Failed to load slider data");
        }
    };


    const handleAddToCart = async (productId) => {
        const res = await fetch(`${url}/grouped-product/single/${productId}`);
        const latestProduct = await res.json();

        if (latestProduct.product_type === "Variable Product") {
            const safeVariation = typeof latestProduct.variation === "string"
                ? JSON.parse(latestProduct.variation)
                : latestProduct.variation || [];

            setVariationModalData({ ...latestProduct, variation: safeVariation });
        } else {
            addProductToCart(latestProduct, latestProduct);
        }

    };


    const syncCartItemsWithLatestProducts = async () => {
        const cartItems = JSON.parse(localStorage.getItem('guest_cart')) || [];

        const updatedCart = await Promise.all(cartItems.map(async (item) => {
            try {
                const res = await fetch(`${url}/grouped-product/single/${item.product_id}`);
                const latest = await res.json();

                return {
                    ...item,
                    product_id: latest.product_id,
                    product_name: latest.title,
                    product_price: latest.originalPrice,
                    product_saleprice: latest.discountPrice,
                    product_stockstatus: latest.stock,
                    product_status: latest.status,
                    product_image: latest.image,
                    product_gallery: latest.gallery || [],
                };
            } catch (e) {
                console.error("Sync error:", e);
                return item;
            }
        }));

        localStorage.setItem('guest_cart', JSON.stringify(updatedCart));
    };

    const addProductToCart = async (variation, baseProduct = null) => {
        const item = {
            product_id: variation.product_id || baseProduct?.product_id,
            product_sku: variation.sku || baseProduct?.sku,
            product_name: baseProduct?.title || variation.title,
            product_price: variation.price || baseProduct?.originalPrice,
            product_saleprice: variation.salePrice || baseProduct?.discountPrice,
            product_stockstatus: variation.stock || baseProduct?.stock,
            product_status: baseProduct?.status || 'Active',
            product_image: variation.imageUrl || baseProduct?.image,
            product_gallery: baseProduct?.gallery || [],
            description: baseProduct?.description || "",
            short_description: baseProduct?.short_description || "",
            category: baseProduct?.category || "",
            product_type: baseProduct.product_type,
            variation_attributes: variation.attributes || {},
            typeofsimple: '',
            user_id: userData?.user_id || null,
            user_name: userData?.name || null,
            delivery_days: baseProduct.delivery_days || "",
            main_id: process.env.REACT_APP_PERFUME_ID,
        };

        if (isLoggedIn) {
            try {
                const response = await fetch(`${url}/cart`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(item),
                });

                const result = await response.json();

                if (!response.ok || result.isError) {
                    toast.warn(result.msg || "Product already in cart");
                    return false;
                } else {
                    await fetchCart(userData?.user_id);
                    toast.success("Added to cart");
                    return true;
                }
            } catch (error) {
                console.error("Add to cart error:", error);
                toast.error("Something went wrong");
            }
        } else {
            const existing = JSON.parse(localStorage.getItem('guest_cart')) || [];
            if (existing.some(p => p.sku === item.product_sku)) {
                toast.warn("Product already in cart");
                return false;
            }
            const updatedCart = [...existing, item];
            localStorage.setItem('guest_cart', JSON.stringify(updatedCart));
            toast.success("Added to cart");
            setCartItemLength(updatedCart.length);
            return true;
        }
    };

    const handleProductClick = (id, name) => {
        // navigate(`/product/${name}/${id}`);
        const encryptedName = btoa(encodeURIComponent(name));
        const encryptedId = btoa(encodeURIComponent(id));

        navigate(`/product/${encryptedName}/${encryptedId}`);



    };

    const getDefaultCartButton = () => {
        const isGetQuoteDefault = cartButtons.find(b => b.button_id === 'getquote' && b.default);
        if (isGetQuoteDefault) return 'getquote';

        const isAddToCartDefault = cartButtons.find(b => b.button_id === 'addtocart' && b.default);
        if (isAddToCartDefault) return 'addtocart';

        const isBuyNowDefault = cartButtons.find(b => b.button_id === 'buynow' && b.default);
        if (isBuyNowDefault) return 'buynow';

        return null; // fallback
    };
    const defaultButton = getDefaultCartButton();

    const handleBuyNow = async (productId) => {
        const res = await fetch(`${url}/grouped-product/single/${productId}`);
        const latestProduct = await res.json();

        if (latestProduct.product_type === "Variable Product") {
            const safeVariation = typeof latestProduct.variation === "string"
                ? JSON.parse(latestProduct.variation)
                : latestProduct.variation || [];

            setVariationModalData({ ...latestProduct, variation: safeVariation });
        } else {
            handleBuyCart(latestProduct, latestProduct);
        }

    };

    const handleBuyCart = (variation, baseProduct = null) => {
        const item = {
            product_id: variation.product_id || baseProduct?.product_id,
            product_sku: variation.sku || baseProduct?.sku,
            product_name: baseProduct?.title || variation.title,
            product_price: Number(variation.price) || baseProduct?.originalPrice,
            product_saleprice: Number(variation.salePrice) || baseProduct?.discountPrice,
            product_stockstatus: variation.stock || baseProduct?.stock,
            product_status: baseProduct?.status || 'Active',
            product_image: variation.imageUrl || baseProduct?.image,
            product_gallery: baseProduct?.gallery || [],
            description: baseProduct?.description || "",
            short_description: baseProduct?.short_description || "",
            category: baseProduct?.category || "",
            product_type: baseProduct.product_type,
            variation_attributes: variation.attributes || {},
            typeofsimple: '',
            user_id: userData?.user_id || null,
            user_name: userData?.name || null,
            delivery_days: baseProduct.delivery_days || "",
            main_id: process.env.REACT_APP_PERFUME_ID,
        };

        const products = [item]
        let discount = 0
        const totalSalePrice = products.reduce((acc, p) => acc + Number(p.product_saleprice), 0);
        const totalBeforeDiscount = products.reduce((acc, p) => acc + Number(p.product_price), 0);
        const totalAfterDiscount = (totalSalePrice - discount).toFixed(2);

        const checkoutDetails = {
            products,
            totalBeforeDiscount: totalBeforeDiscount,
            totalAfterDiscount,
        };

        localStorage.setItem("checkout_data", JSON.stringify(checkoutDetails));
        navigate("/checkout")
    }

    useEffect(() => {
        syncCartItemsWithLatestProducts();
    }, [])

    useEffect(() => {
        sliderFetch();
    }, [])
    return (
        <>
            {/* {slider.length > 0 && current && (
                <div className="home-slider" style={{ backgroundImage: `url(${current?.background_image})` }}>
                    <motion.div
                        className="home-slider-left"
                        key={currentIndex}
                        initial={{ opacity: 0, x: -50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                    >
                        {
                            current?.offer_name && <motion.h3 className="offer-label">{current?.offer_name}</motion.h3>
                        }

                        <motion.h1 className="product-name">{current?.slider_name}</motion.h1>
                        <motion.p className="product-description">{current?.description}</motion.p>

                        {(current?.price || current?.cutOffPrice || current?.price === "" || current?.cutOffPrice === "") && (
                            <motion.div className="product-price">
                                {current?.price && (
                                    <div className="product-discount-price">
                                        <p><span className="discount-price">₹{current.price}</span></p>
                                    </div>
                                )}
                                {current?.cutOffPrice && (
                                    <div className="product-original-price">
                                        <p><del className="original-price">₹{current.cutOffPrice}</del></p>
                                    </div>
                                )}
                            </motion.div>
                        )}

                        {current?.product?.product_id && (
                            <motion.div className="product-btn">
                                {defaultButton === 'addtocart' && (
                                    <button
                                        className="cart-product"
                                        onClick={() => handleAddToCart(current.product.product_id)}
                                    >
                                        <i className="fas fa-shopping-cart"></i> Add to Cart
                                    </button>)}

                                {defaultButton === 'buynow' && (
                                    <button
                                        className="cart-product"
                                        onClick={() => handleBuyNow(current.product.product_id)}
                                    // onClick={() => handleAddToCart(current.product.product_id)}
                                    >
                                        <i className="fas fa-bolt"></i>Buy Now
                                    </button>

                                )}
                                {defaultButton === 'getquote' && (
                                    <button
                                        className="cart-product"
                                        onClick={() => handleProductClick(current.product.product_id, current.product.title)}
                                    >
                                        <i className="fas fa-eye"></i> View
                                    </button>

                                )}

                                <button
                                    className="view-product"
                                    onClick={() => handleProductClick(current.product.product_id, current.product.title)}
                                >
                                    <i className="fas fa-eye"></i> View Product
                                </button>
                            </motion.div>
                        )}

                    </motion.div>

                    <motion.div
                        className="home-slider-right"
                        key={currentIndex + "-img"}
                        initial={{ opacity: 0, x: 50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                    >
                        <img src={current?.image} alt={current?.slider_name} className="product-image" />
                    </motion.div>
                    <button className="slider-btn left" onClick={prevSlide}>
                        <i className="fa fa-chevron-left"></i>
                    </button>
                    <button className="slider-btn right" onClick={nextSlide}>
                        <i className="fa fa-chevron-right"></i>
                    </button>
                </div>
            )} */}
  <AboutMainSection />
            {slider.length > 0 && current && (
                <Slider
                    label={current?.offer_name}
                    title={current?.slider_name}
                    description={current?.description}
                    image={current?.image}
                    price={current?.price}
                    originalPrice={current?.cutOffPrice}
                    onViewProduct={() => handleProductClick(current?.product?.product_id, current?.product?.title)}
                    onAddToCart={() => handleAddToCart(current?.product?.product_id)}
                    currentIndex={currentIndex}
                    setCurrentIndex={setCurrentIndex}
                    sliderData={slider}
                />
            )}


            {variationModalData && (
                <VariationModal
                    product={variationModalData}
                    onClose={() => setVariationModalData(null)}
                    cartButtons={cartButtons}
                    onAddToCart={async (variation) => {
                        const success = await addProductToCart(variation, variationModalData);
                        if (success) {
                            setVariationModalData(null);
                        }
                    }}
                    onAddToBuyNow={async (variation) => {
                        const success = await handleBuyCart(variation, variationModalData);
                        if (success) {
                            setVariationModalData(null); // ✅ Only close if added
                        }
                    }

                    }
                />
            )}

            <CategoryWithImages cartButtons={cartButtons} />
            <NewArrival cartItemsLength={cartItemsLength} setCartItemLength={setCartItemLength} fetchCart={fetchCart} cartButtons={cartButtons} />

            <OfferCards />
            <PopularProducts setCartItemLength={setCartItemLength} fetchCart={fetchCart} cartButtons={cartButtons} />
            <ToastContainer position="top-center" autoClose={3000} />
        </>
    );
};

const VariationModal = ({ product, onClose, onAddToCart, cartButtons, onAddToBuyNow }) => {
    const url = process.env.REACT_APP_API_URL

    const getDefaultCartButton = () => {
        const isGetQuoteDefault = cartButtons.find(b => b.button_id === 'getquote' && b.default);
        if (isGetQuoteDefault) return 'getquote';

        const isAddToCartDefault = cartButtons.find(b => b.button_id === 'addtocart' && b.default);
        if (isAddToCartDefault) return 'addtocart';

        const isBuyNowDefault = cartButtons.find(b => b.button_id === 'buynow' && b.default);
        if (isBuyNowDefault) return 'buynow';

        return null; // fallback
    };

    const defaultButton = getDefaultCartButton();
    return (
        <motion.div className="modal-overlay" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
            <motion.div className="variation-modal" initial={{ y: -50 }} animate={{ y: 0 }}>
                <div className="modal-header">
                    <h2>{product.title} - Choose a Variation</h2>
                    <button className="modal-close" onClick={onClose}><i className="fa fa-times" /></button>
                </div>

                <div className="variation-flex-container">
                    {(Array.isArray(product.variation) ? product.variation : []).map((v, idx) => (
                        <div key={idx} className="variation-flex-card">
                            <img src={`${url}${v.imageUrl}`} alt={v.sku} />
                            <div className="variation-info">
                                <p><strong>SKU:</strong> {v.sku}</p>
                                <p><strong>Price:</strong> ₹{v.price}</p>
                                {v.salePrice && <p><strong>Sale:</strong> ₹{v.salePrice}</p>}
                                <p><strong>Stock:</strong> {v.stock}</p>
                                {defaultButton === 'addtocart' && (
                                    <button onClick={() => onAddToCart(v)} className="add-cart-btn">
                                        Add to Cart
                                    </button>
                                )}
                                {defaultButton === 'buynow' && (
                                    <button onClick={() => onAddToBuyNow(v)} className="add-cart-btn">
                                        Buy Now
                                    </button>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </motion.div>
        </motion.div>
    );
};

export default Home;
